// O lugar de um comentário ao vivo (P-32) e de um lugar parado em ops.held (P-33). Módulo pequeno à parte: o snapshot
// (JS crítico) usa o lugar de ops.held, e o resto dos comentários fica no chunk do painel (B01, §15.7).
import * as z from 'zod/mini';
import { type PlaceCode, PlaceCodeSchema } from './base';

export type CommentScopeLevel = 'BR' | 'UF' | 'MUN' | 'ABROAD_CITY';
export const COMMENT_SCOPE_LEVELS = ['BR', 'UF', 'MUN', 'ABROAD_CITY'] as const satisfies readonly CommentScopeLevel[];

/**
 * Na convenção dos cartões (P-27, `InsightPlace`): BR sem código; UF com `code` = a UF (ou 'ZZ', o Exterior inteiro);
 * MUN com `code` = IBGE de 7 dígitos e `uf`; ABROAD_CITY com `code` = código TSE de 5 dígitos e `uf` = 'ZZ'.
 */
export interface CommentScope {
  level: CommentScopeLevel;
  code?: string;
  uf?: PlaceCode;
}

export const CommentScopeSchema = z.object({
  level: z.enum(COMMENT_SCOPE_LEVELS),
  code: z.optional(z.string()),
  uf: z.optional(PlaceCodeSchema),
});
